import { FC } from 'react'

import { AdsGenresModal } from '../AdsGenresModal'

export const AdsGenresModalsWrapper: FC = () => <AdsGenresModal />
